import Rebase from 're-base';

const base = Rebase.createClass({
    apiKey: "AIzaSyDDWG518C1Y0q57j_Z8YhWac1WwdGrX5bU",
    authDomain: "intuitive-sensitives-admin.firebaseapp.com",
    databaseURL: "https://intuitive-sensitives-admin.firebaseio.com",
});

export default base;



/** WEBPACK FOOTER **
 ** ./src/base.js
 **/